module.exports = __webpack_public_path__ + "static/media/done-tick-icon.3326d7b2.svg";